export default {
    title: 'Registracija',
    invitation_title: 'Pozivnica od strane {caller}',
    finalize_profile: 'Dovršite podešavanje profila',
    subtitle: 'Već imate nalog?',
    sign_in: 'Prijava',
    messages: {
        register_success: 'Registracija završena! Validirajte email da biste nastavili.',
        invite_success: 'Poziv prihvaćen! Ulogujte se da biste nastavili.',
    },
}
